import { useGetApplication } from '../../../hooks';

import { baseUrl } from './services/taxpayerFieldRegistration.service';

export const useGetEnabledRegistrationFields = () => {
  return useGetApplication<Array<string>>({ url: baseUrl, params: {} });
};
